<template>
    <div class="container container--budget-list">

        <Loader v-if="!isReady"></Loader>

        <List v-else
            :filtering="this"
            :itemNameSingular="'budget'"
            :itemNamePlural="'budgets'" >

            <template v-slot:actions>
                    
                <Button class=".native"
                    :disabled="!hasContent"
                    :loading="processingXlsx"
                    @click.native="downloadXlsx">
                    <span class="fa fa-file-excel-o"></span>
                    Télécharger
                </Button>

                <router-link
                    class="woocommerce-button button"
                    :to="{ name: 'budgetNew' }"
                    v-if="$can('CREER_BUDGET') && $setting('BUDGET_CREATE_ENABLED')">Nouveau budget</router-link>

            </template>

            <template v-slot:filters>

                <ListFilter class="filter--main">
                    <input v-model="filters.query"
                        type="text"
                        placeholder="Rechercher un n°, libellé, etc."/>
                </ListFilter>
                <ListFilter>    
                    <Select v-model="filters.status"
                        :options="status"
                        all="Actif / Inactif">
                    </Select>
                </ListFilter>


            </template>

            <template v-slot:heading>
                <div class="cell cell--main criteria">
                    <Sorter criteria="libelle">Libellé</Sorter>
                </div>
                <div class="cell criteria">
                    <Sorter criteria="code">Code</Sorter>
                </div>
                <div class="cell criteria">
                    <Sorter criteria="validiteEndAt">Fin validité</Sorter>
                </div>
                <div class="cell criteria">
                    <Sorter criteria="nextPeriodAt">Remise à zéro le</Sorter>
                </div>
                <div class="cell">
                    Etat
                </div>
                <div class="cell criteria">
                    <Sorter criteria="amount">Crédit restant / total</Sorter>
                </div>
                <div class="cell cell--actions">
                    Actions
                </div>                    
            </template>

            <ul class="list__content budget-list" v-if="hasContent">

                <li class="list__content__item"
                    v-for="budget in items"
                    :key="budget.id">
                                  
                    <ListItem class="list-item--card"
                        :item="budget"
                        :route="route">

                        <Cell type="main">{{ budget.libelle }}</Cell>
                        <Cell>{{ budget.code }}</Cell>
                        <Cell type="date secondary"><Date :date="budget.validiteEndAt" /></Cell>
                        <Cell type="date secondary"><Date :date="budget.nextPeriodAt" v-if="budget.nextPeriodAt" /><span v-else>—</span></Cell>
                        <Cell type="state">
                            <Badge type="warning" v-if="budget.code && !budget.isActive">Inactif</Badge>
                            <Badge type="success" v-if="budget.code && budget.isActive">Actif</Badge>
                            <Badge type="secondary" v-if="!budget.code">En attente</Badge>
                        </Cell>
                        <Cell>
                            <Price :amount="budget.amountRemaining" /> / <Price :amount="budget.amount" />
                        </Cell>
                        <Cell type="actions">
                            <button class="woocommerce-button button"
                                @click.prevent="edit(budget)"
                                v-if="$can('MODIFIER_BUDGET') && $setting('BUDGET_UPDATE_ENABLED')">
                                <span class="fa fa-edit"></span>
                            </button>
                        </Cell>
                        
                    </ListItem>

                </li>

            </ul>

            <div class="container_list container_list--no-result" v-else>
                <h1 class="woocommerce-order-details__title" v-show="!isFiltering">Aucun budget</h1>
            </div>

            <div class="list__next" v-if="hasMore">
                <Loader v-if="isLoadingMore"></Loader>
                <button
                    class="button"
                    type="button"
                    @click="next"
                    v-else>Voir les budgets suivants</button>
            </div>

        </List>

    </div>
</template>

<script>
import Badge from '@/components/badge/Badge.vue'
import Button from '@/components/button/Button.vue'
import Date from '@/components/date/Date.vue'
import List, { Cell, ListFilter, ListItem, Sorter }  from '@/components/list/List.vue'
import Loader from '@/components/loader/Loader.vue'
import Price from '@/components/price/Price.vue'
import Select  from '@/components/select/Select.vue'

import api from '@/api/proxyWeb/budgets'
import Router, { routes } from '@/router'

import filtering from "@/containers/filtering";

export default {

    name: 'BudgetList',

    data: function() {
        return {
            filters: {
                query: '',
                status: null
            },
            processingXlsx: false,
            route: routes.BUDGET
        }
    },

    computed: {

        status: () => {
            return [
                { value: 'active', name: 'Oui' },
                { value: 'inactive', name: "Non" }
            ]         
        }
    },

    methods: {

        downloadXlsx() {
            this.processingXlsx = true
            api.getXlsx(this.params)
                .then(() => { this.$notify.success('Téléchargement en cours...') })
                .finally(() => { this.processingXlsx = false } )
        },

        edit: function(budget) {
            Router.push({
                name: routes.BUDGET_EDIT,
                params: { id: budget.id }
            });
        },
    },
  
    created () {
        this.useFilter(api)
    },

    components: {
        Badge,
        Button,
        Cell,
        Date,
        List,
        ListFilter,
        ListItem,
        Loader,
        Price,
        Select,
        Sorter
    },

    mixins: [ filtering ]
}
</script>

<style scoped>

.table {
    width: 100%;
}

.table__action {
    color: #17a2b8;
}

.table__data {}

.table__data--main {
    font-weight: 700;
}

.table__data--no-result {
    text-align: center;
    opacity: 0.8;
}

.table__row {
    cursor: pointer;
}

.negative {
    color: rgb(255, 48, 0);
}

</style>
